import { CornerRadius, DataTable } from '@makyoapp/makyo-tw-ui'

import { LayoutDemo } from './LayoutDemo'

export const DatatableDemo = () => {
  const columns = [
    {
      accessorKey: 'X76nbZ',
      header: 'Short Text',
      meta: {
        columnType: 'text',
        tooltipEnabled: false,
      },
      enableSorting: false,
    },
    {
      accessorKey: 't48gEU',
      header: 'Email',
      meta: {
        columnType: 'email',
        tooltipEnabled: false,
      },
      enableSorting: false,
    },
  ]

  const data = [
    {
      _id: 'a3fe1b07-9457-4ddb-baf9-27af8f095430',
      X76nbZ: "I'll input the bluetooth FTP feed, that should transmit the IB driver!",
      t48gEU: 'malikaweissnat@buckridge.biz',
    },
    {
      _id: '0745929e-0940-407b-8044-7c1a70a417da',
      X76nbZ: 'Try to verify the USB matrix, maybe it will transpile the virtual capacitor!',
      t48gEU: 'zorarosenbaum@barrows.com',
    },
    {
      _id: '70f1b479-761e-4c13-be74-517e96a3fdee',
      X76nbZ: "You can't bundle the pixel without connecting the haptic SAS sensor!",
      t48gEU: 'elwyndickens@aufderhar.org',
    },
    {
      _id: '5312202f-0446-4402-a8b9-6dc105c7a748',
      X76nbZ: 'If we calculate the alarm, we can get to the USB hard drive through the online CSS application!',
      t48gEU: 'alekwilliamson@aufderhar.com',
    },
    {
      _id: '0419561a-f512-48b4-a13a-cd0ce21d71a6',
      X76nbZ: "I'll write the primary TCP feed, that should program the PNG feed!",
      t48gEU: 'aylinkunde@schmitt.net',
    },
    {
      _id: '86fbfee7-23dc-4792-9d12-b6e6bcd0d3f0',
      X76nbZ: 'Try to input the RAM capacitor, maybe it will quantify the cross-platform firewall!',
      t48gEU: 'anabelzulauf@kertzmann.info',
    },
    {
      _id: '91529126-bb64-474a-a190-0d6ef820fbe3',
      X76nbZ: "Copying the feed won't do anything, we need to copy the 1080p SMS bus!",
      t48gEU: 'baileechamplin@haley.info',
    },
    // {
    //   _id: '91529126-bb64-474a-a190-0d6ef820fbe3',
    //   X76nbZ: "Copying the feed won't do anything, we need to copy the 1080p SMS bus!",
    //   t48gEU: 'baileechamplin@haley.info',
    // },
    // {
    //   _id: '91529126-bb64-474a-a190-0d6ef820fbe3',
    //   X76nbZ: "Copying the feed won't do anything, we need to copy the 1080p SMS bus!",
    //   t48gEU: 'baileechamplin@haley.info',
    // },
  ]

  const settings = {
    oddRowColor: 'primary-90',
    evenRowColor: 'primary-95',
    headerFooterColor: 'primary-80',
    borderColor: 'primary-90',
    cornerRadius: 'medium' as CornerRadius,
    showGlobalFilter: false,
    showColumnToggle: false,
    headerTypography: 'body-small' as any,
    footerTypography: 'body-small' as any,
    titleTypography: 'body-small' as any,
    rowHeaderTypography: 'body-small' as any,
    rowItemTypography: 'body-small' as any,
    bodyTypography: 'body-small' as any,
  }

  return (
    <LayoutDemo title='Datatable' bgColor='var(--color-primary-90)'>
      <DataTable columns={columns} data={data} {...settings} />
    </LayoutDemo>
  )
}
